export default "__VITE_ASSET__xkN6hsiu__"